
import React from 'react';
import { FileText } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface ScheduleBasicFieldsProps {
  title: string;
  setTitle: (value: string) => void;
  type: 'appointment' | 'admin' | 'break' | 'leave' | 'mc';
  setType: (value: 'appointment' | 'admin' | 'break' | 'leave' | 'mc') => void;
}

const ScheduleBasicFields: React.FC<ScheduleBasicFieldsProps> = ({
  title,
  setTitle,
  type,
  setType,
}) => {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <div>
        <Label htmlFor="title" className="text-sm font-medium">
          <FileText className="inline-block h-4 w-4 mr-2" />
          Title
        </Label>
        <Input id="title" value={title} onChange={(e) => setTitle(e.target.value)} />
      </div>
      <div>
        <Label htmlFor="type" className="text-sm font-medium">Type</Label>
        <Select value={type} onValueChange={setType}>
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="appointment">Appointment</SelectItem>
            <SelectItem value="admin">Admin</SelectItem>
            <SelectItem value="break">Break</SelectItem>
            <SelectItem value="leave">Leave</SelectItem>
            <SelectItem value="mc">Urgent Leave</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default ScheduleBasicFields;
